import { sendJSON } from './send_json';

const Legacy = { sendJSON };

export default Legacy;
